module.exports = __webpack_public_path__ + "static/media/bulb-off.fb1c027a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Bulbs/bulb-off.svg
// module id = 1588
// module chunks = 0